var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyko(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E86013"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.821 20.83l-8.11 4.1-.216.108c-1.366.695-2.552 1.296-4.073.75a3.797 3.797 0 01-1.748-1.25 3.214 3.214 0 01-.672-1.965v-7.267l.205-.273s2.38-2.763 6.017-2.752c1.465 0 2.674.547 3.893 1.093 1.278.574 2.57 1.154 4.085.913v1.662c-1.853.23-3.319-.43-4.768-1.094-1.053-.472-2.099-.94-3.21-.942-2.323.005-4.01 1.432-4.563 1.984v6.676c0 .354.116.7.332.982.254.321.597.563.987.696.83.304 1.728-.15 2.749-.67.381-.196-.127.064.221-.114l5.943-2.992.436.122a6.965 6.965 0 002.49.233h.002z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.683 16.285a4.538 4.538 0 013.11-.719c1.405.153 2.506.68 3.61 1.208.771.363 1.573.66 2.397.889 1.059.311 3.418.245 4.148-.66a1.862 1.862 0 00.476-1.629 2.144 2.144 0 00-.648-1.171 1.888 1.888 0 00-.379-.274l-11.31-6.285-.036-.022a2.822 2.822 0 00-1.335-.418 2.248 2.248 0 00-1.198.232 1.554 1.554 0 00-.619.661c-.168.323-.25.682-.238 1.044v1.093c.965-.51 2.434-.984 4.51-.902v1.618c-2.934-.112-4.629.965-6.169 2.378V9.185a3.708 3.708 0 01.423-1.845 3.195 3.195 0 011.289-1.325 3.893 3.893 0 012.101-.451 4.534 4.534 0 012.107.661l-.036-.022 11.308 6.286c.255.143.492.315.705.514a3.79 3.79 0 011.14 2.071c.161.811.028 1.652-.377 2.375a3.576 3.576 0 01-.5.686c-1.217 1.457-4.076 1.662-5.808 1.12a16.499 16.499 0 01-2.674-1.005c-.973-.465-1.935-.93-3.069-1.055a3.808 3.808 0 00-2.928.954v-1.864z",
    fill: "#fff"
  })));
}

export default SvgEyko;